import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useDatePickerMonthYearSelectorClassNames } from './hooks/useDatePickerMonthYearSelectorClassNames';
import { useDatePickerMonthYearSelector } from './hooks/useDatePickerMonthYearSelector';
import { DatePickerMonthYearSelectorRoot, DatePickerMonthYearSelectorScroll, DatePickerMonthYearSelectorList, DatePickerMonthYearSelectorYear, DatePickerMonthYearSelectorYearTitle, DatePickerMonthYearSelectorMonthList, DatePickerMonthYearSelectorMonth } from './style';
import { DATE_PICKER_MONTH_YEAR_SELECTOR_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../../utils/hooks';
export var DatePickerMonthYearSelector = forwardRef(function DatePickerMonthYearSelector(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(DATE_PICKER_MONTH_YEAR_SELECTOR_CLASS_PREFIX);
  var classNameComponents = useDatePickerMonthYearSelectorClassNames(DATE_PICKER_MONTH_YEAR_SELECTOR_CLASS_PREFIX, className);

  var _useDatePickerMonthYe = useDatePickerMonthYearSelector(props, ref),
      rootProps = _useDatePickerMonthYe.rootProps,
      scrollProps = _useDatePickerMonthYe.scrollProps,
      listProps = _useDatePickerMonthYe.listProps,
      yearTitleProps = _useDatePickerMonthYe.yearTitleProps,
      monthProps = _useDatePickerMonthYe.monthProps,
      months = _useDatePickerMonthYe.months,
      yearRange = _useDatePickerMonthYe.yearRange,
      displayedYear = _useDatePickerMonthYe.displayedYear,
      displayedMonth = _useDatePickerMonthYe.displayedMonth,
      openYear = _useDatePickerMonthYe.openYear;

  return React.createElement(DatePickerMonthYearSelectorRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(DatePickerMonthYearSelectorScroll, Object.assign({}, scrollProps, {
    theme: theme,
    className: classNameComponents.Scroll
  }), React.createElement(DatePickerMonthYearSelectorList, Object.assign({}, listProps, {
    theme: theme,
    className: classNameComponents.List
  }), yearRange.map(function (year) {
    return React.createElement(DatePickerMonthYearSelectorYear, {
      theme: theme,
      className: classNameComponents.Year,
      key: year
    }, React.createElement(DatePickerMonthYearSelectorYearTitle, Object.assign({}, yearTitleProps, {
      theme: theme,
      className: classNameComponents.YearTitle,
      "data-year": year
    }), year), openYear === year && React.createElement(DatePickerMonthYearSelectorMonthList, {
      theme: theme,
      className: classNameComponents.MonthList
    }, months.map(function (monthName, monthNumber) {
      return React.createElement(DatePickerMonthYearSelectorMonth, Object.assign({}, monthProps, {
        theme: theme,
        className: classNameComponents.Month,
        key: monthName,
        "data-month": monthNumber,
        "data-year": year,
        selected: monthNumber === displayedMonth && year === displayedYear
      }), monthName);
    })));
  }))));
});
DatePickerMonthYearSelector.defaultProps = {};